import axios from "axios";
import {
  moneyHubAllConnectionsUrl,
  moneyHubTestConnectionUrl,
  verifiedMoneyHubBaseUrl,
} from "../../constants";

export const moneyHubFetchAllConnections = async () => {
  return await axios({
    method: "GET",
    url:
      process.env.REACT_APP_NODE_ENV === "production"
        ? moneyHubAllConnectionsUrl
        : moneyHubTestConnectionUrl,
  })
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        return [];
      }
    })
    .catch(async (err) => {
      console.error(
        "moneyhub fetch all connections requestfailed with error: ",
        err.message
      );

      return [];
    });
};

export const moneyHubConnectLink = async (userId) => {
  const redirectUri =
    window.location.origin !== "http://localhost:3000"
      ? window.location.origin + "/"
      : "https://veripay-bac0b.web.app/";
  const url = `${verifiedMoneyHubBaseUrl}/connect-link?redirect_uri=${redirectUri}&user_id=${userId}`;
  if (url) {
    return await axios({
      method: "GET",
      url: url,
    })
      .then((res) => {
        if (res.data?.body?.link) {
          return res.data?.body?.link;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "moneyhub connect link request failed with error: ",
          err.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const moneyHubConnectAccessToken = async (code, idToken, userId) => {
  const redirectUri =
    window.location.origin !== "http://localhost:3000"
      ? window.location.origin + "/"
      : "https://veripay-bac0b.web.app/";
  return await axios({
    method: "POST",
    url: `${verifiedMoneyHubBaseUrl}/connect-token`,
    data: {
      code: code,
      id_token: idToken,
      redirect_uri: redirectUri,
      user_id: userId,
    },
  })
    .then((res) => {
      if (res.data?.body?.tokens?.access_token) {
        return res.data?.body?.tokens?.access_token;
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error(
        "moneyhub connect tokens request failed with error: ",
        err?.message
      );

      return null;
    });
};

export const moneyHubCreateUserAccessToken = async (userAddress) => {
  return await axios({
    method: "POST",
    url: `${verifiedMoneyHubBaseUrl}/create-user-token`,
    data: {
      user_address: userAddress,
    },
  })
    .then((res) => {
      if (res.data?.body?.tokens?.access_token) {
        return res.data?.body?.tokens?.access_token;
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error(
        "moneyhub create user token request failed with error: ",
        err?.message
      );

      return null;
    });
};

export const moneyHubUserAccounts = async (accessToken) => {
  const url = `${verifiedMoneyHubBaseUrl}/user-accounts?access_token=${accessToken}`;
  if (url) {
    return await axios({
      method: "GET",
      url: url,
    })
      .then((res) => {
        if (res.data?.body?.accounts) {
          return res.data?.body?.accounts;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "moneyhub user accounts request failed with error: ",
          err.message
        );

        return null;
      });
  } else {
    return null;
  }
};

export const moneyHubCreateUser = async (userAddress) => {
  const accessToken = await moneyHubCreateUserAccessToken(userAddress);
  if (accessToken) {
    return await axios({
      method: "POST",
      url: `${verifiedMoneyHubBaseUrl}/create-user`,
      data: {
        access_token: accessToken,
        user_address: userAddress,
      },
    })
      .then((res) => {
        if (res.data?.body?.user) {
          return res.data?.body?.user;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error("moneyhub create user failed with error: ", err.message);

        return null;
      });
  } else {
    return null;
  }
};

export const moneyHubClientUserAccessToken = async (userId) => {
  return await axios({
    method: "POST",
    url: `${verifiedMoneyHubBaseUrl}/connect-user-token`,
    data: {
      user_id: userId,
    },
  })
    .then((res) => {
      if (res.data?.body?.tokens?.access_token) {
        return res.data?.body?.tokens?.access_token;
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error(
        "moneyhub connect user token failed with error: ",
        err?.message
      );

      return null;
    });
};

export const moneyHubPaymentLink = async (
  payerId,
  payerBankId,
  payerBankAccountId,
  payerBankConnectionId,
  payerName,
  payerEmail,
  amountInPence,
  payeeId,
  payeeBankAccountId,
  paymentContext
) => {
  const redirectUri =
    window.location.origin !== "http://localhost:3000"
      ? window.location.origin + "/"
      : "https://veripay-bac0b.web.app/";
  return await axios({
    method: "POST",
    url: `${verifiedMoneyHubBaseUrl}/payment-link`,
    data: {
      payer_id: payerId,
      payer_bank_id: payerBankId,
      payer_bank_account_id: payerBankAccountId,
      payer_bank_connection_id: payerBankConnectionId,
      payer_name: payerName,
      payer_email: payerEmail,
      amount_in_pence: amountInPence,
      payee_id: payeeId,
      payee_bank_account_id: payeeBankAccountId,
      context: paymentContext,
      redirect_uri: redirectUri,
    },
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error("moneyhub payment link failed with error: ", err?.message);

      return null;
    });
};

export const moneyHubPaymentToken = async (code, idToken, state) => {
  return await axios({
    method: "POST",
    url: `${verifiedMoneyHubBaseUrl}/payment-token`,
    data: {
      code,
      id_token: idToken,
      state,
    },
  })
    .then((res) => {
      if (res.data?.body?.tokens?.access_token) {
        return res.data?.body?.tokens?.access_token;
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error("moneyhub payment token failed with error: ", err?.message);

      return null;
    });
};

export const moneyHubCompletePayment = async (
  accessToken,
  code,
  idToken,
  state,
  paymentId
) => {
  const redirectUri =
    window.location.origin !== "http://localhost:3000"
      ? window.location.origin + "/"
      : "https://veripay-bac0b.web.app/";
  return await axios({
    method: "PATCH",
    url: `${verifiedMoneyHubBaseUrl}/complete-payment`,
    data: {
      access_token: accessToken,
      code,
      id_token: idToken,
      state,
      redirect_uri: redirectUri,
      payment_id: paymentId,
    },
  })
    .then((res) => {
      if (res.data?.body?.data?.data) {
        return {
          data: res.data?.body?.data?.data,
          link: res.data?.body?.link,
        };
      } else {
        return null;
      }
    })
    .catch(async (err) => {
      console.error(
        "moneyhub complete payment failed with error: ",
        err?.message
      );

      return null;
    });
};
